import { Autocomplete, Switch, TextField } from "@mui/material";
import { LINEAR_PRIORITIES } from "../../utils/constants";
import {
  AutocompleteOption,
  IntegrationSettings,
} from "../../utils/interfaces";

interface Props {
  settings: any;
  linearProjects: AutocompleteOption[];
  linearTeams: AutocompleteOption[];
  handleInputChange: (field: keyof IntegrationSettings, value: any) => void;
}

const LinearSection: React.FC<Props> = ({
  settings,
  linearProjects,
  linearTeams,
  handleInputChange,
}) => {
  return (
    <div className='space-y-4'>
      <div className='flex items-center font-medium'>
        <Switch
          checked={settings.pushAutoIdentifiedIssues || false}
          onChange={(event, checked) =>
            handleInputChange("pushAutoIdentifiedIssues", checked)
          }
          data-testid='autoPushSwitch'
        />
        <p>
          Push auto-identified issues in Sailfish to Engineering Ticketing
          platform
        </p>
      </div>
      <Autocomplete
        options={linearTeams}
        getOptionLabel={(option) => option.name}
        value={
          linearTeams.find(({ id }) => id === settings.defaultTeam) || null
        }
        onChange={(event, value) =>
          handleInputChange("defaultTeam", value?.id || "")
        }
        isOptionEqualToValue={(option, value) => option.id === value.id}
        renderInput={(params) => (
          <TextField {...params} label='Default Team' variant='outlined' />
        )}
        data-testid="teamInput"
      />
      <Autocomplete
        options={linearProjects}
        getOptionLabel={(option) => option.name}
        value={
          linearProjects.find(({ id }) => id === settings.defaultProject) ||
          null
        }
        onChange={(event, value) =>
          handleInputChange("defaultProject", value?.id || "")
        }
        isOptionEqualToValue={(option, value) => option.id === value.id}
        renderInput={(params) => (
          <TextField {...params} label='Default Project' variant='outlined' />
        )}
        data-testid="projectInput"
      />
      <Autocomplete
        disableClearable
        options={LINEAR_PRIORITIES}
        getOptionLabel={(option) => option.name}
        value={LINEAR_PRIORITIES.find(
          ({ value }) => value === settings.defaultPriority,
        )}
        onChange={(event, newValue) =>
          handleInputChange("defaultPriority", newValue?.value || 0)
        }
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => (
          <TextField {...params} label='Default Priority' variant='outlined' />
        )}
        data-testid="priorityInput"
      />
    </div>
  );
};

export default LinearSection;
